/*
 *    Copyright (c) 2018-2025, sems All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: sems
 */
import request from '@/router/axios'
import qs from 'qs'
import {useUserStore} from '@/stores/user.js'
import { getStore, setStore } from '@/utils/store.js'
import website from '@/const/website.js'
import { encryptUser } from '@/utils'

const scope = 'server'

export const loginByUsername = (username, password, code, randomStr) => {
  const grant_type = 'password'
  const dataObj = qs.stringify({ 'username': username, 'password': password })
  const basicAuth = 'Basic ' + window.btoa(website.formLoginClient)

  // 保存当前选中的 basic 认证信息
  setStore({
    name: 'basicAuth',
    content: basicAuth,
    type: 'session'
  })

  return request({
    url: '/auth/oauth/token',
    headers: {
      isToken: false,
      'Authorization': basicAuth
    },
    method: 'post',
    params: { randomStr, code, grant_type },
    data: dataObj
  })
}

export const refreshToken = (refresh_token) => {
  const grant_type = 'refresh_token'
  // 获取当前选中的 basic 认证信息
  const basicAuth = getStore({ name: 'basicAuth' })

  return request({
    url: '/auth/oauth/token',
    headers: {
      'isToken': false,
      'Authorization': basicAuth
    },
    method: 'post',
    params: { refresh_token, grant_type, scope }
  })
}

export const loginByMobile = (mobile, code) => {
  const grant_type = 'mobile'
  const basicAuth = 'Basic ' + window.btoa(website.smsLoginClient)

  // 保存当前选中的 basic 认证信息
  setStore({
    name: 'basicAuth',
    content: basicAuth,
    type: 'session'
  })

  return request({
    url: '/auth/oauth/token',
    headers: {
      isToken: false,
      'Authorization': basicAuth
    },
    method: 'post',
    params: { mobile: 'SMS@' + mobile, code: code, grant_type }
  })
}

export const loginBySocial = (state, code, tenantId) => {
  const grant_type = 'mobile'
  const basicAuth = 'Basic ' + window.btoa(website.socialLoginClient)

  // 保存当前选中的 basic 认证信息
  setStore({
    name: 'basicAuth',
    content: basicAuth,
    type: 'session'
  })

  return request({
    url: '/auth/oauth/token',
    headers: {
      isToken: false,
      'Authorization': basicAuth,
      'TENANT-ID': tenantId
    },
    method: 'post',
    params: { mobile: state + '@' + code, code: code, grant_type }
  })
}

export const getUserInfo = () => {
  return request({
    url: '/admin/user/info',
    method: 'get'
  })
}

export const signOut = () => {
  return request({
    url: '/auth/token/logout',
    method: 'delete'
  })
}

/**
 * 校验令牌，若有效期小于半小时自动续期
 * @param refreshLock
 */
export const checkToken = (refreshLock, $store) => {
  const userStore = useUserStore()
  const token = userStore.access_token
  // 获取当前选中的 basic 认证信息
  const basicAuth = getStore({ name: 'basicAuth' })

  request({
    url: '/auth/oauth/check_token',
    headers: {
      isToken: false,
      Authorization: basicAuth
    },
    method: 'get',
    params: { token }
  }).then(response => {
    const expire = response && response.data && response.data.exp
    if (expire) {
      const expiredPeriod = expire * 1000 - new Date().getTime()
      //小于半小时自动续约
      if (expiredPeriod <= 30 * 60 * 1000) {
        if (!refreshLock) {
          refreshLock = true
          $store.dispatch('RefreshToken')
            .catch(() => {
              clearInterval(this.refreshTime)
            })
          refreshLock = false
        }
      }
    }
  })
}

/**
 * 注册用户
 */
export const registerUser = (userInfo) => {
  return request({
    url: '/admin/register/user',
    method: 'post',
    data: userInfo
  })
}

/**
 * 找回密码
 */
export const retrievePassword = (params) => {
  return request({
    url: `/admin/yzmSms/retrieve/${params.tenant}/${params.phone}`,
    method: 'get'
  })
}

/**
 * 根据登录名和密码获取租户list
 */
export const getTenantList = (params) => {

  let user = {}
  user = website.passwordEnc ? encryptUser(params) : params

  const grant_type = 'password'
  const basicAuth = 'Basic ' + window.btoa(website.formLoginClient)

  setStore({ name: 'basicAuth', content: basicAuth, type: 'session' })

  return request({
    url: '/admin/user/tenant',
    headers: {
      isToken: false,
      'Authorization': basicAuth
    },
    method: 'post',
    params: { randomStr: user.randomStr, code: user.code, grant_type },
    data: qs.stringify({ 'username': user.username, 'password': user.password })
  })
}
/**
 * 根据微信code获取租户list
 */
export function getTenantListByWxCode(code) {
  return request({
    url: '/admin/user/tenant/WX/' + code,
    headers: {
      isToken: false,
      Authorization: 'Basic ' + window.btoa('social:social')
    }
  })
}
